export default __webpack_public_path__ + "static/edit-pricing-stock-27853e92addf3e37f2822a6039959107.png";